<template>
  <div>
    <a-card
      style="width:100%"
      :tabList="tabListNoTitle"
      :activeTabKey="noTitleKey"
      @tabChange="key => onTabChange(key, 'noTitleKey')"
    >
      <div v-if="noTitleKey === 'articleClass'">
        <a-table :columns="columns" :dataSource="data" rowKey="id">
          <span slot="action" slot-scope="text, record">
            <a-button type="primary" @click="showModal(record, 2)" :ghost="true">添加子分类</a-button> &nbsp;&nbsp;
            <a-button type="primary" :ghost="true" @click="showModal(record, 3)">编辑</a-button> &nbsp;&nbsp;
            <a-button type="danger" @click="showDeleteConfirm(record)">删除</a-button>
          </span>
        </a-table>
      </div>
      <div v-else-if="noTitleKey === 'addClass'">
        <a-form
          :form="form"
          @submit="handleSubmit"
        >
          <a-form-item
            label="上级分类"
            :label-col="{ span: 2 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-select
              v-decorator="[
                'parent_id',
                {rules: [{ required: true, message: '请选择上级分类!' }]}
              ]"
              placeholder="选择上级分类"

            >
              <a-select-option value="0">作为一级菜单</a-select-option>
              <a-select-option v-for="(item, index) in treeList" :key="index" :value="item.id">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            label="分类名称"
            :label-col="{ span: 2 }"
            :wrapper-col="{ span: 20 }"
          >
            <a-input
              v-decorator="[
                'name',
                {rules: [{ required: true, message: '输入分类名称!' }]}
              ]"
            />
          </a-form-item>
          <a-form-item
            label="分类说明"
            :label-col="{ span: 2 }"
            :wrapper-col="{ span: 20 }"
          >
            <a-textarea
              :rows="4"
              class="text-area"
              v-decorator="[
                'description',
                {rules: [{ required: true, message: '请输入分类说明!' }]}
              ]"
            />
          </a-form-item>
          <a-form-item
            :wrapper-col="{ span: 5, offset: 2 }"
          >
            <a-button
              type="primary"
              html-type="submit"
            >
              提交
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
    <!-- 注意：新增工具、添加子分类、编辑为同一个组件 -->
    <operation ref="showOperation" @ok="handleOk"/>
  </div>
</template>

<script>
import Operation from './modules/Operation'
import pick from 'lodash.pick'
import { getAiticleCategoryList, addAiticleCategory, delAiticleCategory } from '@/api/manage'
const columns = [
  {
    title: '分类ID',
    dataIndex: 'id',
    key: 'id',
    width: '14%'
  },
  {
    title: '分类名称',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '分类说明',
    dataIndex: 'description',
    key: 'description',
    width: '40%'
  }, {
    title: '操作',
    dataIndex: 'action',
    width: '30%',
    key: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

const data = []
export default {
  components: {
    Operation
  },
  data () {
    return {
      tabListNoTitle: [
        {
          key: 'articleClass',
          tab: '分类管理'
        },
        {
          key: 'addClass',
          tab: '新增分类'
        }
      ],
      noTitleKey: 'articleClass',

      // 分类列表数据
      data,
      columns,
      // 新建分类表单
      formLayout: 'horizontal',
      form: this.$form.createForm(this)
    }
  },
  mounted () {
    this.handleInitList()
  },
  computed: {
    treeList () {
      const tree = []
      this.data.forEach((val, key) => {
        tree.push({
          id: val.id,
          name: val.name
        })
        if (val.children && val.children.length > 0) {
          val.children.forEach((v, k) => {
            tree.push({
              id: v.id,
              name: '├─' + v.name
            })
          })
        }
      })
      return tree
    }
  },
  methods: {
    handleOk () {
      this.handleInitList()
    },
    onTabChange (key, type) {
      this[type] = key
    },
    handleInitList () {
      this.loading = true
      return getAiticleCategoryList({})
        .then(res => {
          this.data = res.result
        })
        .finally(() => {
          this.loading = false
        })
    },
    showModal (record, type) {
      //                console.log(record)
      this.$refs.showOperation.show(this.data, record, type)
    },
    // 新建分类表单提交
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const formData = pick(values, ['parent_id', 'name', 'description'])
          this.handleCreate(formData)
        }
      })
    },
    handleCreate (formData) {
      addAiticleCategory(formData)
        .then((res) => {
          this.$emit('ok', formData) // 子组件将数据带到父组件
          this.$message.success(res.msg)
          this.form.resetFields()
          this.visible = false
        }).catch((e) => this.requestFailed(e))
        .finally(() => {
          this.confirmLoading = false
        })
    },
    // 删除
    showDeleteConfirm (record) {
      this.$confirm({
        title: '确定删除当前分类?',
        content: '',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          this.loading = true
          return delAiticleCategory({
            articleCategoryId: record.id
          })
            .then(res => {
              this.$message.success(res.msg)
              this.handleInitList()
            })
            .catch((err) => this.requestFailed(err))
            .finally(() => {
              this.loading = false
            })
        },
        onCancel () {
          // console.log('Cancel')
        }
      })
    },
    requestFailed (err) {
      // console.log(err)
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    }
  }
}
</script>

<style>
    .text-area {
        resize: none;
    }
</style>
